import { render, staticRenderFns } from "./disqualificationTreatment-list.vue?vue&type=template&id=7b2b72f6&scoped=true&"
import script from "./disqualificationTreatment-list.vue?vue&type=script&lang=js&"
export * from "./disqualificationTreatment-list.vue?vue&type=script&lang=js&"
import style0 from "./disqualificationTreatment-list.vue?vue&type=style&index=0&id=7b2b72f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b72f6",
  null
  
)

export default component.exports